import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.assign";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { isNumericValue as _isNumericValue } from '../../../../utils/vuex';
import LineChartMixin from '@/components/core/dtwin/lineChartMixin';
import { getTimeArrayFromRangeKey } from '@/components/core/dateTime/pickerParseRangeValues.js';
import { set, get } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
var boolVisual = {
  firstStateTitle: '',
  secondStateTitle: '',
  firstFaIcon: '',
  secondFaIcon: '',
  firstColor: '',
  secondColor: ''
};
export default {
  name: 'CoreDtwinStateEditVisual',
  mixins: [LineChartMixin],
  props: {
    // the current edited binding
    value: {
      type: Object,
      required: true
    },
    hideSelection: {
      type: Boolean,
      default: false
    },
    hidePreview: {
      type: Boolean,
      default: false
    },
    helpText: {
      type: String,
      required: false,
      default: function _default() {
        return null;
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      lclModel: {
        properties: {
          visual: {
            options: {}
          }
        }
      },
      lastEmit: {
        properties: {
          visual: {
            options: {}
          }
        }
      },
      updateVisual: 0,
      valueWasChanged: false,
      stateIsNull: get(this.lclModel, 'value.value') === null,
      skipTransformer: true,
      requiredRule: [function (v) {
        return v !== '' || _this.$i18n_t('Common.fieldRequired');
      }],
      decimalRules: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }, function (v) {
        return v && v < 10 || _this.$i18n_t('DigitalTwin.DigitalTwin.visualization.maxDecimalPoints');
      }],
      yAxisRules: [function (v) {
        return !v || !isNaN(parseFloat(v));
      }],
      tresholdRule: true,
      rawData: false
    };
  },
  computed: _objectSpread(_objectSpread({
    formIsValid: function formIsValid() {
      return this.tresholdRule === true;
    }
  }, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    stateValue: function stateValue() {
      if (this.lclModel.properties.valueType === 'json') {
        try {
          return JSON.stringify(get(this.lclModel, 'value.value'), null, 1);
        } catch (error) {// on error we return outside of try/catch
        }
      }

      this.sanitiseVisualOptions();
      return get(this.lclModel, 'value.value');
    },
    isNumericValue: function isNumericValue() {
      return _isNumericValue(get(this.lclModel, 'value.value'));
    },
    getVisualType: function getVisualType() {
      return get(this.lclModel, 'properties.visual.type');
    },
    isNumberType: function isNumberType() {
      return this.lclModel.properties.valueType === 'number';
    },
    isBooleanType: function isBooleanType() {
      return this.lclModel.properties.valueType === 'boolean';
    },
    isStringType: function isStringType() {
      return this.lclModel.properties.valueType === 'string';
    },
    isJsonType: function isJsonType() {
      return this.lclModel.properties.valueType === 'json';
    },
    showVisualization: function showVisualization() {
      return this.isNumberType || this.isBooleanType || this.isStringType || this.isJsonType;
    },
    getDropdownItems: function getDropdownItems() {
      if (this.isNumberType) {
        return this.numDropdownValues;
      }

      if (this.isBooleanType) {
        return this.boolDropdownValues;
      }

      if (this.isStringType || this.isJsonType) {
        return this.stringJsonDropdownValues;
      }

      return false;
    },
    numDropdownValues: function numDropdownValues() {
      return [{
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.none'),
        value: null
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.gauge'),
        value: 'gauge'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.donut'),
        value: 'donut'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.odometer'),
        value: 'odometer'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.battery'),
        value: 'battery'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.lineChart'),
        value: 'lineChart'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.hidden'),
        value: 'hidden'
      }];
    },
    boolDropdownValues: function boolDropdownValues() {
      var booleanItems = [{
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.none'),
        value: null
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.lineChart'),
        value: 'lineChart'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.hidden'),
        value: 'hidden'
      }];

      if (this.lclModel.properties.binding.type === 'none' && this.lclModel.properties.valueType === 'boolean') {
        var buttonItem = {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.button'),
          value: 'button'
        };
        booleanItems.splice(1, 0, buttonItem);
      }

      return booleanItems;
    },
    stringJsonDropdownValues: function stringJsonDropdownValues() {
      return [{
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.none'),
        value: null
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.components.hidden'),
        value: 'hidden'
      }];
    },
    isLclModelValueNull: function isLclModelValueNull() {
      return get(this.lclModel, 'value.value') === null;
    },
    boolVisualFaIcon: function boolVisualFaIcon() {
      return get(this.lclModel, 'value.value') ? this.lclModel.properties.visual.options.boolVisual.firstFaIcon : this.lclModel.properties.visual.options.boolVisual.secondFaIcon;
    },
    boolVisualFaIconColor: function boolVisualFaIconColor() {
      return get(this.lclModel, 'value.value') ? this.lclModel.properties.visual.options.boolVisual.firstColor : this.lclModel.properties.visual.options.boolVisual.secondColor;
    },
    boolVisualStateTitle: function boolVisualStateTitle() {
      return get(this.lclModel, 'value.value') ? this.lclModel.properties.visual.options.boolVisual.firstStateTitle : this.lclModel.properties.visual.options.boolVisual.secondStateTitle;
    }
  }),
  watch: {
    stateIsNull: function stateIsNull(val, oldVal) {
      if (val === true && oldVal !== true) {
        set(this.lclModel, 'value.value', null);
      }
    },
    stateValue: function stateValue() {
      this.stateIsNull = get(this.lclModel, 'value.value') === null;
    },
    'lclModel.properties.visual.options.decimalPoints': {
      handler: function handler(newVal) {
        if (parseInt(newVal) > 10) {
          this.lclModel.properties.visual.options.decimalPoints = 10;
        }
      }
    },
    minYAxis: function minYAxis() {
      this.$emit('input');
    },
    maxYAxis: function maxYAxis() {
      this.$emit('input');
    },
    rawData: {
      handler: function handler() {
        var _this2 = this;

        if (this.rawData) {
          this.min = false;
          this.max = false;
          this.average = false;
          this.latest = false;
        } // if disabled again, enable at least 1 option by default again


        if (!this.rawData) {
          var options = ['min', 'max', 'average', 'latest']; // check if OTHER options are selected as well

          if (options.map(function (o) {
            return _this2[o];
          }).filter(function (o) {
            return o;
          }).length === 0) {
            this.average = true;
          }
        }

        var lclModelClone = cloneDeep(this.lclModel);
        lclModelClone.properties.visual.options.rawData = this.rawData;
        this.lclModel = lclModelClone;
        this.$emit('input');
      }
    },
    value: {
      handler: function handler(newVal) {
        var lclModel = cloneDeep(newVal);

        if (!lclModel.value) {
          lclModel.value = {};
        }

        this.sanitiseVisualOptions(lclModel);
        this.setConfigStateData(lclModel);
        this.loadChartDataDebounced(lclModel);
        this.validateThresholds(lclModel);
        this.lclModel = lclModel;
        this.updateIntervalSelect(lclModel);
      },
      deep: true,
      immediate: true
    },
    lclModel: {
      handler: function handler(newVal) {
        if (isEqual(this.lastEmit, newVal)) {
          return;
        }

        this.rawData = this.lclModel.properties.visual.options.rawData === true;
        this.$emit('value:updated', newVal);
        this.lastEmit = cloneDeep(newVal);
      },
      deep: true
    }
  },
  methods: {
    shouldOptionCheckboxBeDisabled: function shouldOptionCheckboxBeDisabled(option) {
      var _this3 = this;

      if (option !== 'rawData' && this.rawData) {
        return true;
      }

      if (option === 'rawData') {
        // always allow the "rawData" checkbox, see handler that will disable all other options on selection
        return false;
      }

      var options = ['min', 'max', 'average', 'latest'].filter(function (o) {
        return o !== option;
      }); // check if OTHER options are selected as well

      return options.map(function (o) {
        return _this3[o];
      }).filter(function (o) {
        return o;
      }).length === 0;
    },
    sanitiseVisualOptions: function sanitiseVisualOptions(lclModelClone) {
      var overwriteLclModel = false;

      if (!lclModelClone) {
        lclModelClone = cloneDeep(this.lclModel);
        overwriteLclModel = true;
      }

      if (!lclModelClone.properties.visual) {
        lclModelClone.properties.visual = {
          type: null,
          options: {}
        };
      }

      if (!lclModelClone.properties.visual.options) {
        lclModelClone.properties.visual.options = {};
      }

      if (lclModelClone.properties.valueType === 'boolean') {
        if (!get(lclModelClone, 'properties.visual.options.boolVisual')) {
          // need to deep-clone it here, otherwise the global constant retains the changes even if `editVisual` instance gets destroyed
          Object.assign(lclModelClone.properties.visual.options, {
            boolVisual: cloneDeep(boolVisual)
          });
        }

        if (lclModelClone.properties.visual.options.boolVisual.firstStateTitle === '') {
          lclModelClone.properties.visual.options.boolVisual.firstStateTitle = 'true';
        }

        if (lclModelClone.properties.visual.options.boolVisual.secondStateTitle === '') {
          lclModelClone.properties.visual.options.boolVisual.secondStateTitle = 'false';
        }
      }

      if (overwriteLclModel) {
        this.lclModel = lclModelClone;
      }
    },
    setTimeSpan: function setTimeSpan() {
      var unixTs = getTimeArrayFromRangeKey(this.queryTimeSpan);
      this.queryStartDate = new Date(unixTs[0] * 1000);
      this.queryEndDate = new Date(unixTs[1] * 1000);
      var lclModelClone = cloneDeep(this.lclModel);
      lclModelClone.properties.visual.options.queryTimeSpan = this.queryTimeSpan;
      this.lclModel = lclModelClone;
      this.updateIntervalSelect();
    },
    updateIntervalSelect: function updateIntervalSelect() {
      var _this4 = this;

      var _getTimeArrayFromRang = getTimeArrayFromRangeKey(this.queryTimeSpan),
          _getTimeArrayFromRang2 = _slicedToArray(_getTimeArrayFromRang, 2),
          startDate = _getTimeArrayFromRang2[0],
          endDate = _getTimeArrayFromRang2[1];

      var diff = Math.floor(endDate - startDate);
      var diffInMins = Math.floor(diff / 60);
      var diffInDays = Math.floor(diff / 60 / 60 / 24);
      this.items.forEach(function (item) {
        item.disabled = false;
      });

      if (diffInDays > 30) {
        // disable first three options
        this.items[0].disabled = true;
        this.items[1].disabled = true;
        this.items[2].disabled = true;
        this.interval = '1d';
      } else if (diffInDays < 30) {
        var durationsInMins = [5, 15, 60, 1440, 10080, 43200];
        var upperBoundDurationIndex = durationsInMins.findIndex(function (x) {
          return diffInMins < x;
        }); // if smaller or equal to 5 then [5], otherwise the upperBoundDurationIndex.
        // example1: upperBoundDuration is 60 -> index: 2, then allowed is index 2

        var maximumAllowedDurationIndex = upperBoundDurationIndex ? upperBoundDurationIndex : 1; // follow example 1: allowedDurations = ['5m', '15m']

        this.items.forEach(function (item, itemIndex) {
          if (itemIndex >= maximumAllowedDurationIndex) {
            item.disabled = true;
          }
        }); // use the minimum between max allowed and stored interval
        // if max allowed is 1h and stored interval is 15m, then use 15m
        // if max allowed is 1h and stored interval is 1d, then use 1h

        var currentIntervalIndex = this.items.findIndex(function (x) {
          return x.timeVal === _this4.interval;
        });
        this.interval = this.items[Math.min(currentIntervalIndex, maximumAllowedDurationIndex - 1)].timeVal;
      }
    },
    getVisualCols: function getVisualCols() {
      if (!this.lclModel.properties.visual.type || this.hidePreview) {
        return 12;
      } else if (this.lclModel.properties.visual.type === 'lineChart') {
        return 6;
      }

      return 9;
    },
    sanitizeThresholds: function sanitizeThresholds(string) {
      return string.split(',').map(function (item) {
        return parseFloat(item);
      }).filter(function (item) {
        return !isNaN(item);
      }).sort(function (a, b) {
        return a - b;
      });
    },
    onVisualChanged: function onVisualChanged(type) {
      var lclModelClone = cloneDeep(this.lclModel);
      lclModelClone.properties.visual.type = type;
      lclModelClone.properties.visual.options = {};

      if (type === 'odometer') {
        lclModelClone.properties.visual.options.minimumLength = '8';
        lclModelClone.properties.visual.options.decimalPoints = '2';
      }

      if (type === 'gauge') {
        lclModelClone.properties.visual.options.min = '0';
        lclModelClone.properties.visual.options.max = '100';
        lclModelClone.properties.visual.options.decimalPoints = 2;
        lclModelClone.properties.visual.options.thresholds = '50';
        lclModelClone.properties.visual.options.reverse = false;
        lclModelClone.properties.visual.options.thresColors = ['#ff1744', '#fb8c00'];
      }

      this.lclModel = lclModelClone;
    },
    valueFieldEdited: function valueFieldEdited() {
      var lclModelClone = cloneDeep(this.lclModel);
      this.updateVisual = Date.now();
      this.valueWasChanged = true;
      var visualType = ((lclModelClone.properties || {}).visual || {}).type || null;

      if (visualType === 'gauge') {
        var threshColors = lclModelClone.properties.visual.options.thresColors; // filter non number items out of the comma separated string and sort array

        var thresholds = this.sanitizeThresholds(lclModelClone.properties.visual.options.thresholds); // write sanitized threshold values as comma separated string back to model

        lclModelClone.properties.visual.options.thresholds = thresholds.join(',');
        var diff = thresholds.length - threshColors.length;

        if (thresholds.length === 0) {
          threshColors.splice(0);
        } else if (thresholds.length < threshColors.length) {
          threshColors.splice(thresholds.length + 1, diff * -1);
        } else {
          for (var i = 0; i <= diff; i++) {
            // first color is red following colors orange
            threshColors.push(threshColors.length + i === 0 ? '#ff1744' : '#fb8c00');
          }
        }
      }

      this.lclModel = lclModelClone;
    },
    saveState: function saveState() {
      if (this.stateIsNull) {
        this.lclModel.value = {
          value: null
        };
      }

      if (this.lclModel.properties.valueType === 'number') {
        set(this.lclModel, 'value.value', parseFloat(get(this.lclModel, 'value.value')));
      }

      this.lclModel.value.hasChanged = this.valueWasChanged;
      this.lclModel.value.skipTransformer = this.skipTransformer;
    },
    getDecimalPoints: function getDecimalPoints(decimalPoints) {
      if (decimalPoints && !isNaN(decimalPoints)) {
        return parseFloat(decimalPoints);
      } else {
        return 0;
      }
    },
    validateThresholds: function validateThresholds(lclModelClone) {
      if (!lclModelClone) {
        lclModelClone = cloneDeep(this.lclModel);
      }

      if (!get(lclModelClone, 'properties.visual.options.thresholds')) {
        return;
      }

      lclModelClone.properties.visual.options.thresholds.split(',').map(function (threshold) {
        return parseFloat(threshold);
      }).find(function (threshold) {
        return isNaN(threshold) || threshold <= parseFloat(lclModelClone.properties.visual.options.min) || threshold >= parseFloat(lclModelClone.properties.visual.options.max);
      }) ? this.tresholdRule = this.$i18n_t('DigitalTwin.DigitalTwin.visualization.invalidThreshold') : this.tresholdRule = true;
      this.$emit('input');
    }
  }
};